import Cookies from 'js-cookie'
export const checkForSavedState = () => {
    if ($(".result-list-is-present").length > 0 && Cookies.get("savedStateFromLogon") && String(window.location).indexOf("#") == -1) {
        window.location = window.location + "#" + Cookies.get("savedStateFromLogon");
        Cookies.remove("savedStateFromLogon", {
            path: '/',
            domain: document.domain
        });
    }
};
